import React from 'react';

export const BadgeSvg: React.FC<{ width: number; height: number; color: string }> = ({ width, height, color }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 43"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M17.854.2C8.946.2 0 7.224 0 7.224v18.921C0 31.162 12.488 39.62 17.854 42.2 24 39.763 36 31.162 36 26.145V7.224S26.762.2 17.854.2Z"
      fill="white"
    />
    <path
      d="M17.801 1.981C9.668 1.981 1.5 8.342 1.5 8.342V25.48c0 4.544 11.402 12.203 16.301 14.54 5.612-2.207 16.569-9.996 16.569-14.54V8.342s-8.435-6.36-16.569-6.36Z"
      fill={color}
    />
    <path
      d="M27.167 13.333h-3.611v-1.389a.831.831 0 0 0-.834-.833h-9.444a.831.831 0 0 0-.834.833v1.39h-3.61a.831.831 0 0 0-.834.833v1.944c0 1.24.781 2.514 2.15 3.497 1.093.788 2.423 1.288 
           3.819 1.447 1.09 1.81 2.364 2.556 2.364 2.556v2.5h-1.666c-1.226 0-2.223.719-2.223 1.944v.417c0 .23.188.417.417.417H23.14c.23 0 .417-.188.417-.417v-.417c0-1.225-.997-1.944-2.223-1.944h-1.666v-2.5s1.274-.746 
           2.364-2.556c1.4-.16 2.73-.66 3.82-1.447C27.215 18.625 28 17.35 28 16.11v-1.944a.831.831 0 0 0-.833-.834Zm-15.72 4.472c-.846-.61-1.225-1.291-1.225-1.694v-.556h2.23c.034 1.133.2 2.125.444 2.994a5.597 5.597 0 
           0 1-1.448-.744Zm14.33-1.694c0 .56-.614 1.254-1.225 1.694a5.619 5.619 0 0 1-1.451.744c.243-.869.41-1.861.444-2.993h2.233v.555Z"
      fill={color}
    />
  </svg>
);

export const RibbonSvg: React.FC<{ color: string }> = ({ color }) => (
  <svg
    width="180"
    height="24"
    fill="none"
    viewBox="0 0 180 26"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.012 1h149.272a1 1 0 0 1 1 1v2.53h11.652a1 1 0 0 1 .785 1.62l-6.315 7.995a1 1 0 0 0 0 1.24l6.315 7.995a1 1 0 0 1-.785 1.62H150.54a1 1 0 0 1-1-1v-1.823H30.024V24a1 1 0 0 1-1 1H2.155a1 1 0 0 1-.763-1.646L8.14 15.38a1 1 0 0 0 .03-1.255L1.233 5.08a1 1 0 0 1 .794-1.608h12.985V2a1 1 0 0 1 1-1Z"
      fill={color}
    />
    <path
      d="M166.284 4.53v16.646a1 1 0 0 1-1 1H149.54M166.284 4.53V2a1 1 0 0 0-1-1H16.012a1 1 0 0 0-1 1v1.47m151.272 1.06h11.652a1 1 0 0 1 .785 1.62l-6.315 7.995a1 1 0 0 0 0 1.24l6.315 7.995a1 1 0 0 1-.785 1.62H150.54a1 1 0 0 1-1-1v-1.823m0 0H30.024M15.011 3.47v17.706a1 1 0 0 0 1 1h14.011M15.012 3.47H2.027a1 1 0 0 0-.794 1.608l6.937 9.046a1 1 0 0 1-.03 1.255l-6.747 7.974A1 1 0 0 0 2.156 25h26.867a1 1 0 0 0 1-1v-1.823"
      stroke={'black'}
      strokeOpacity="0.15"
      strokeWidth="1px"
    />
    <path d="m149.54 25 16.166-3H149.54v3ZM30.023 24.571 14.434 22h15.59v2.571Z" fill={'black'} fillOpacity="0.15" />
  </svg>
);
